import * as React from 'react';
import { FixMeLater } from '../../../utils';

export interface ModularPriceFormattedProps {
    /**
     * The pre-formatted price value.
     */
    children?: string;
}

export const ModularPriceFormatted: React.ForwardRefExoticComponent<
    ModularPriceFormattedProps & React.RefAttributes<HTMLElement>
> = React.forwardRef(function ModularPriceFormatted(
    props: ModularPriceFormattedProps,
    ref: React.ForwardedRef<FixMeLater>
): React.JSX.Element {
    const { children, ...other } = props;
    return (
        <span ref={ref} data-offscreen={true} {...other}>
            {children}
        </span>
    );
});
